module.exports = __webpack_public_path__ + "img/vertical_6_4_8023.9323f8b1.png";